import * as a from "./a";
import * as b from "./b";
import * as c from "./c";
import * as d from "./d";
import * as e from "./e";
import * as f from "./f";
import * as g from "./g";
import * as h from "./h";
import * as i from "./i";
import * as k from "./k";
import * as l from "./l";
import * as m from "./m";
import * as n from "./n";
import * as o from "./o";
import * as p from "./p";
import * as q from "./q";
import * as r from "./r";
import * as s from "./s";
import * as t from "./t";
import * as v from "./v";
import * as w from "./w";

const iconsList = [
  ...a.iconsList,
  ...b.iconsList,
  ...c.iconsList,
  ...d.iconsList,
  ...e.iconsList,
  ...f.iconsList,
  ...g.iconsList,
  ...h.iconsList,
  ...i.iconsList,
  ...k.iconsList,
  ...l.iconsList,
  ...m.iconsList,
  ...n.iconsList,
  ...o.iconsList,
  ...p.iconsList,
  ...q.iconsList,
  ...r.iconsList,
  ...s.iconsList,
  ...t.iconsList,
  ...v.iconsList,
  ...w.iconsList,
]

export {
  iconsList,
  a,
  b,
  c,
  d,
  e,
  f,
  g,
  h,
  i,
  k,
  l,
  m,
  n,
  o,
  p,
  q,
  r,
  s,
  t,
  v,
  w,
}